import LoadingScreenComponent from "components/generalComponents/loadingScreenComponent/LoadingScreenComponent";
import { AuthenticationContext } from "context/AuthenticationContext";
import { Navigate, useNavigate } from "react-router";
import { DataFormat } from "utils/format/DataFormat";
import Main from "./Main";

function PrivateRoute({ children, ...rest }) {
  const token = DataFormat.getToken();
  const navigate = useNavigate();
  const { menuConfig } = AuthenticationContext();

  if (!token) return <Navigate to="/login" />;

  return (
    <Main location={window.location} navigate={navigate}>
      {!menuConfig ? <LoadingScreenComponent /> : children}
    </Main>
  );
}

export default PrivateRoute;
